/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Toolbar from "./toolbar"
import GlobalStyle from "../styles/global"

const Layout = ({ children, withToolbar, onToolbarClick, freeze, view }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <GlobalStyle freeze={freeze} />
      <Header siteTitle={data.site.siteMetadata.title} withToolbar={withToolbar} />
      {withToolbar && <Toolbar onClick={onToolbarClick} view={view} />}
      <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  withToolbar: PropTypes.bool,
}

Layout.defaultProps = {
  withToolbar: false,
}

export default Layout
